(() => {
  class NoventraGallery {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-nv-slide]'));
      this.current = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.current < 0) this.current = 0;
      this.counter = root.querySelector('[data-nv-current]');
      root.querySelector('[data-nv-prev]')?.addEventListener('click', () => this.go(this.current - 1));
      root.querySelector('[data-nv-next]')?.addEventListener('click', () => this.go(this.current + 1));
      this.update();
    }
    go(index) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.update();
    }
    goToMedia(mediaId) {
      const index = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
      if (index >= 0) { this.current = index; this.update(); }
    }
    update() {
      this.slides.forEach((slide, index) => {
        const active = index === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        const video = slide.querySelector('video');
        if (video && !active) video.pause?.();
      });
      if (this.counter) this.counter.textContent = String(this.current + 1).padStart(2, '0');
    }
  }

  const galleries = new Map();
  document.querySelectorAll('[data-nv-gallery]').forEach((root) => galleries.set(root.dataset.nvGallery, new NoventraGallery(root)));

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const gallery = galleries.get(String(data.sectionId));
      const mediaId = data.variant?.featured_media?.id;
      if (gallery && mediaId) gallery.goToMedia(mediaId);
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-nv-gallery]').forEach((root) => {
      if (!galleries.has(root.dataset.nvGallery)) galleries.set(root.dataset.nvGallery, new NoventraGallery(root));
    });
  });
})();
